import { offerCreationStepViewed } from 'services/typewriter';

import {
  getEntity,
  segmentBrandObject,
  segmentOfferObject,
  segmentCompanyObject,
  segmentContextObject,
} from './helpers';

export default async ({ offer, stepName }: Data) => {
  const brand = await getEntity('brands', offer['brand']);
  const company = await getEntity('companies', brand['company']);
  offerCreationStepViewed({
    context: segmentContextObject(company, brand),
    brand: segmentBrandObject(brand, company),
    company: segmentCompanyObject(company),
    offer: segmentOfferObject(offer),
    stepName,
  });
};
